import {AllUserRoles, CompanyRoles} from 'Authority'
import RouteConstant from 'constants/RouteConstant'
import CommonLayout from 'layouts/Common'
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import RouteIf from 'routes/RouteIf'

import useProductManagement from 'features/productManagement/useProductManagement'
import ProductOrderList from 'pages/ProductOrderPages/ProductOrderList'
import ProductOrderPayment from 'pages/ProductOrderPages/ProductOrderPayment'

export default function ProductOrderRoute() {
  const {getAllPackageList} = useProductManagement()

  useEffect(() => {
    getAllPackageList()
  }, [])

  return (
    <CommonLayout>
      <Switch>
        <RouteIf
          requiredRoles={AllUserRoles}
          path={RouteConstant.PRODUCTS_ORDER.path}
          exact
          component={ProductOrderList}
        />
        <RouteIf
          requiredRoles={AllUserRoles}
          path={RouteConstant.PRODUCTS_PAYMENT.path}
          exact
          component={ProductOrderPayment}
        />

        <Route path='*'>
          <Redirect to={RouteConstant.ERROR_NOT_FOUND.path} />
        </Route>
      </Switch>
    </CommonLayout>
  )
}
